export const showSearchForm = () => {
    
};

export const showNavBar = () => {
    $('#nav-open-close').click(function() {

      if( $('#nav-open-close').hasClass('open') ){
        closeMenu();
      } else {
       	//abrir
        $('#header').addClass('menu-opened');
        $('#nav-open-close').addClass('open');
        $('.header__desplegable').addClass('show');

        //cerrar el search window si está abierto
        if( $('.search-window').hasClass('show') ){
            closeSearch();
        }
      }
    });

    $('#hide-button-close-menu').click(function() {
        closeMenu();
    });
    $('#close-menu').click(function() {
        closeMenu();
    });

    //search

    $('#search').click(function() {
      if( $('.search-window').hasClass('show') ){
        closeSearch();
      } else {
        //abrir
        $('.search-window').addClass('show');
        //cerrar el menu si está abierto
        if( $('#nav-open-close').hasClass('open') ){
            closeMenu();
        }
      }

    });
    $('#hide-button-close-search').click(function() {
        closeSearch();
    });
    $('#close-search').click(function() {
        closeSearch();
    });


};

function closeMenu(){
    $('#header').removeClass('menu-opened');
    $('.header__desplegable').removeClass('show');
    $('#nav-open-close').removeClass('open');
}
function closeSearch(){
    $('.search-window').removeClass('show');
}